import React, { useEffect, useState } from 'react';
import { useGetAssignmentsQuery } from '../features/assignment/assignmentApi';
import { useGetVideosQuery } from '../features/videos/videosApi';

const useGetUnUsedVideoId = ({ extraId, shouldGiveAllId } = {}) => {
    const [status, setStatus] = useState({
        isLoading: true,
        isError: false,
        uniqIdVideos: []
    })
    const { data: videos, isLoading: isVideosLoading, isError: isVideoError, } = useGetVideosQuery()
    const { data: assignments, isLoading: isAssignmentLoading, isError: isAssignmentError, } = useGetAssignmentsQuery()

    useEffect(() => {

        if (isVideosLoading || isAssignmentLoading) {
            setStatus(pre => ({
                ...pre,
                isLoading: true,
            }))
        } else if (isAssignmentError || isVideoError) {
            setStatus(pre => ({
                ...pre,
                isLoading: false,
                isError: true,
            }))

        }
        else {
            const usedVideoIdInAssignment = assignments.map(single => single.video_id)
            let uniqIdVideos = videos.filter(single => !usedVideoIdInAssignment.includes(single.id))

            if (extraId) {

                const extraVideo = videos.find(single => single.id === extraId)
                uniqIdVideos = [extraVideo, ...uniqIdVideos]
            }
            if (shouldGiveAllId) {
                uniqIdVideos = videos
            }
            setStatus(pre => ({
                ...pre,
                uniqIdVideos,
                isLoading: false,
            }))
        }
    }, [isVideosLoading, isAssignmentLoading, isVideoError, isAssignmentError, assignments, videos])


    return status
};

export default useGetUnUsedVideoId;